(function() {
	// globals
	PM.Projects = {};
	PM.Projects.showArchived = false;

	// app functions
		PM.Projects.renderProjectsPage = function() {
		PM.Shell.setSidebarActive('projects');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Projects') }]);
		var showArchived = PM.Projects.showArchived || false;
		var url = showArchived ? '/api/projects?archived=true' : '/api/projects';
		$.when(
			$.get(url),
			ejs.preloadTemplate('/app/projects/templates/project-row.ejs'),
			ejs.preloadTemplate('/app/projects/templates/project-modal.ejs')
		).done(function(projectsResult) {
			var projects = projectsResult[0];
			$('.js-page-container').html(ejs.rr('/app/projects/templates/projects.ejs', { projects: projects }));
			var $btn = $('.js-projects-toggle-archived');
			if ($btn.length) {
				$btn.text(PM.Projects.showArchived ? i18next.t('Hide archived') : i18next.t('Show archived'));
			}
		});
	};

	// Show the add/edit modal
	PM.Projects.showModal = function(project) {
		var isEdit = !!project;
		var modalTitle = isEdit ? i18next.t('Edit Project') : i18next.t('Add Project');

		var modalHtml = ejs.rr('/app/projects/templates/project-modal.ejs', {
			modalTitle: modalTitle,
			project: project || {}
		});

		var $modal = $(modalHtml);
		$('body').append($modal);
		var bsModal = new bootstrap.Modal($modal[0]);
		bsModal.show();

		// Clean up on hidden
		$modal.on('hidden.bs.modal', function() {
			$modal.remove();
		});

		// Focus first input
		$modal.on('shown.bs.modal', function() {
			$modal.find('.js-project-name').focus();
		});
	};

	// events

	// "Add Project" button
	$(document).on('click', '.js-projects-add', function(e) {
		e.preventDefault();
		PM.Projects.showModal(null);
	});

	// Edit button on a row
	$(document).on('click', '.js-projects-edit', function(e) {
		e.preventDefault();
		var id = $(this).data('project-id');
		$.get('/api/projects/' + id, function(project) {
			PM.Projects.showModal(project);
		});
	});

	// Save button in modal
	$(document).on('click', '.js-projects-save', function() {
		var $modal = $(this).closest('.js-projects-modal');
		var id = $modal.find('.js-project-id').val();
		var name = $modal.find('.js-project-name').val().trim();
		var description = $modal.find('.js-project-description').val().trim();

		if (!name) {
			new Notify({ status: 'error', text: i18next.t('Name is required.'), timeout: 3000 });
			return;
		}

		var data = {
			name: name,
			description: description || null,
			archived: $modal.find('.js-project-archived').is(':checked')
		};

		var request;
		if (id) {
			request = $.ajax({
				url: '/api/projects/' + id,
				method: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		} else {
			request = $.ajax({
				url: '/api/projects',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			});
		}

		request.done(function() {
			bootstrap.Modal.getInstance($modal[0]).hide();
			PM.Projects.renderProjectsPage();
			new Notify({ status: 'success', text: i18next.t('Project saved.'), timeout: 3000 });
		});
	});

	// Delete button on a row
	$(document).on('click', '.js-projects-delete', function(e) {
		e.preventDefault();
		var id = $(this).data('project-id');
		var name = $(this).data('project-name');

		if (!confirm(i18next.t('Delete') + ' "' + name + '"? ' + i18next.t('This action cannot be undone.'))) {
			return;
		}

		$.ajax({
			url: '/api/projects/' + id,
			method: 'DELETE'
		}).done(function() {
			PM.Projects.renderProjectsPage();
			new Notify({ status: 'success', text: i18next.t('Project deleted.'), timeout: 3000 });
		});
	});

	// Archive / Unarchive button on a row
	$(document).on('click', '.js-projects-archive', function(e) {
		e.preventDefault();
		var id = $(this).data('project-id');
		var archived = $(this).data('archived') == '1';
		var newArchived = !archived;

		$.ajax({
			url: '/api/projects/' + id,
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ name: $(this).data('project-name'), archived: newArchived })
		}).done(function(project) {
			PM.Projects.renderProjectsPage();
			new Notify({ status: 'success', text: project.archived ? i18next.t('Project archived.') : i18next.t('Project unarchived.'), timeout: 3000 });
		});
	});

	// Toggle show/hide archived projects
	$(document).on('click', '.js-projects-toggle-archived', function() {
		PM.Projects.showArchived = !PM.Projects.showArchived;
		PM.Projects.renderProjectsPage();
	});

	// app startup
	page('/projects', PM.Shell.routeWithPermission('view_projects', PM.Projects.renderProjectsPage));
})();
